import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  textField: {
    width: 350,
    maxWidth: 350,
    margin: 0,
    borderColor: '#e8e9ec',
    '& input': {
      padding: '8px 10px 7px',
      backgroundColor: '#fff',
      fontSize: 15,
    },
    '&.tableInput': {
      padding: 0,
    },
    '&.filter': {
      width: 170,
      '& input': {
        padding: '9px 10px 8px',
      },
    },
  },
}));

const NewInput = (props) => {
  const {
    type,
    className,
    name,
    params,
    value = '',
    useBlur = true,
    callBack = (f) => f,
    InputProps = null,
    inputType = 'text',
    ...rest
  } = props;
  const classes = useStyles();
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    if (value !== inputValue) {
      setInputValue(value);
    }
    // eslint-disable-next-line
  }, [value]);

  const handleParams = (e) => {
    if (useBlur) {
      const { value } = e.target;
      let newParams = { ...params };
      newParams = {
        ...newParams,
        [name]: value,
      };
      if (JSON.stringify(params) !== JSON.stringify(newParams)) {
        callBack(newParams, name);
      }
    }
  };

  const handleOnChange = (e) => {
    if (inputType === 'price') {
      const value = e.target.value;
      let numFormat = numberFormat(value, true, true, true);
      setInputValue(numFormat);
    } else {
      setInputValue(e.target.value);
    }
  };

  //숫자 입력 (마이너스, 소수점, 콤마)
  const numberFormat = (val, isMinus, isFloat, isComma) => {
    let str = val;
    //일단 마이너스, 소수점을 제외한 문자열 모두 제거
    str = str.replace(/[^-.0-9]/g, '');
    //마이너스
    str = chgMinusFormat(str);

    //소수점
    if (isFloat) {
      str = chgFloatFormat(str);
    }

    //콤마
    if (isComma) {
      let parts = str.toString().split('.');
      if (str.substring(str.length - 1, str.length) === '.') {
        str = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.';
      } else {
        str =
          parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
          (parts[1] ? '.' + parts[1] : '');
      }
    }

    return str;
  };

  const chgFloatFormat = (str) => {
    let idx = str.indexOf('.');
    if (idx < 0) {
      return str;
    } else if (idx > 0) {
      let tmpStr = str.substr(idx + 1);
      if (tmpStr.length > 1) {
        if (tmpStr.indexOf('.') >= 0) {
          tmpStr = tmpStr.replace(/[^\d]+/g, '');
          str = str.substr(0, idx + 1) + tmpStr;
        }
      }
    } else if (idx === 0) {
      str = '0' + str;
    }
    return str;
  };

  const chgMinusFormat = (str) => {
    let idx = str.indexOf('-');
    if (idx === 0) {
      let tmpStr = str.substr(idx + 1);
      //뒤에 마이너스가 또 있는지 확인
      if (tmpStr.indexOf('-') >= 0) {
        tmpStr = tmpStr.replace('-', '');
        str = str.substr(0, idx + 1) + tmpStr;
      }
    } else if (idx > 0) {
      str = str.replace('-', '');
    } else if (idx < 0) {
      return str;
    }
    return str;
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      const { value } = e.target;
      let newParams = { ...params };
      newParams = {
        ...newParams,
        [name]: value,
      };
      if (JSON.stringify(params) !== JSON.stringify(newParams)) {
        callBack(newParams, name);
      }
    }
  };
  return (
    <>
      <TextField
        className={clsx(
          type === 'tableInput' && 'tableInput',
          type === 'filter' && 'filter',
          classes.textField,
          className
        )}
        variant="outlined"
        InputProps={InputProps}
        onChange={handleOnChange}
        onKeyPress={handleKeyPress}
        onBlur={handleParams}
        value={inputValue}
        size="small"
        type={inputType}
        {...rest}
      />
    </>
  );
};

export default NewInput;
